import { getFeature } from 'Cloud/Application/FeaturesEs6';

const multiTariffAdvancedOverquotaValue: 'a' | 'b' | undefined = getFeature('multi-tariff-advanced-overquota');
export const isMultiTariffAdvancedOverquota = multiTariffAdvancedOverquotaValue === 'b';

type TariffList = {
    year?: string[];
    month: string[];
};

export const multiTariffAdvancedOverquotaList: TariffList = getFeature('multi-tariff-advanced-overquota-list') || {
    month: [
        'W256GB_1m_landing_segmentation_main',
        'W512GB_1m_landing_segmentation_main',
        'W1TB_1m_landing_segmentation_main',
        'W2TB_1m_landing_segmentation_main',
    ],
};
